<template>
    <div>
        <modal :show="newMileageModalActive"
            footer-classes="justify-content-center"
            type="notice"
            v-on:close="onModalClose"
        >
            <h5 slot="header" class="modal-title">{{ $t( "myFleet.newMileage") }}</h5>

            <template>
                <form class="form-horizontal">
                    <p class="text-info text-center mileage-warning-km" v-if="newMileageData.lastDocumentedMileage">{{ $t( "myFleet.lastDocumentedMileage") }} {{formatMileage(newMileageData.lastDocumentedMileage)}} km</p>
                    <div class="text-info text-center mileage-warning-date" v-if="newMileageData.lastDocumentedMileageDate">{{formatDate(newMileageData.lastDocumentedMileageDate)}}</div>
                    <div class="row">
                        <label class="col-md-4 col-form-label">{{ $t( "myFleet.newMileage") }}</label>
                        <div class="col-md-8">
                            <div class="form-group">
                                <input
                                    class="form-control"
                                    :placeholder='$t( "myFleet.enterNewMileage")'
                                    :value="newMileageData.newMileage"
                                    v-imask="mileageMask"
                                    @accept="onAccept($event)"
                                    @complete="onComplete"
                                    :unmask="true"
                                    unmaskedValue
                                >
                            </div>
                        </div>
                    </div>
                    <p class="text-danger text-center mileage-warning">{{newMileageData.mileageWarning}}</p>
                </form>
            </template>
            <div slot="footer" class="justify-content-center">
                <el-button class="custom-button" type="primary" @click.native="sendMileage" :disabled="apiInProgress" :loading="apiInProgress">{{ $t( "myFleet.sendMileage") }}</el-button>
            </div>
        </modal>
    </div>
</template>
<script>


    import {Button} from 'element-ui'
    import moment from 'moment'


    import {Modal} from 'src/components/UIComponents';
    import alerts from 'src/util/alerts.js'

    import swal from 'sweetalert2';
    import {IMaskDirective} from 'vue-imask';
    import Vue from 'vue'

    Vue.use(Button)



  export default {
        inheritAttrs: false,
        name: 'new-mileage',
        components: {
            Modal
        },
        props: {
            newMileageModalActive: {
                type: Boolean,
                description: ''
            },
            apiInProgress: {
                type: Boolean,
                description: ''
            },
            label: {
                type: String,
                description: ''
            },
            vehicleSelected: {
                type: String,
                description: ''
            }
        },
        data() {
            return {
                newMileageData: {
                    mileageWarning: ''
                },
                mileageUnmasked: '',
                mileageMask: {
                    mask: Number,
                    scale: 0,
                    thousandsSeparator: '.',
                    min: 0,
                    max: 999999
                },
                onAccept (e) {
                    this.newMileageData.mileageWarning = '';
                    const maskRef = e.detail;
                    this.newMileageData.newMileage = maskRef._value;
                    this.mileageUnmasked = maskRef._unmaskedValue;
                },
                onComplete (e) {
                    const maskRef = e.detail;
                }
            }
        },
        watch: {
            vehicleSelected(newVal) {
              if (!newVal) return;
              let mileageObject = this.$store.fleet.store.fleetData.data.contracts.find( ({auto}) => auto._id === newVal).mileage;
              if (mileageObject && mileageObject.lastDocumentedMileage) {
                this.newMileageData.lastDocumentedMileage = mileageObject.lastDocumentedMileage.km;
                this.newMileageData.lastDocumentedMileageDate = mileageObject.lastDocumentedMileage.mileageDate.sec;
              }
              else {
                this.newMileageData.lastDocumentedMileage = null;
                this.newMileageData.lastDocumentedMileageDate = null;
              }
            }
        },
        computed: {
        },
        methods: {
            formatMileage(mileage) {
                if (!mileage || mileage === 'null' || mileage === '-') return '-';
                mileage = Math.round(mileage);
                mileage = mileage.toString();
                if (mileage !== '' || mileage !== undefined || mileage !== 0  || mileage !== '0' || mileage !== null) {
                return mileage.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                }
                return mileage
            },
            formatDate(date) {
                if (!date || date === '-') return '-';
                let dateM = moment(date * 1000);
                if (!dateM.isValid()) {
                  dateM = moment(date, 'DD.MM.YYYY');
                  if (!dateM.isValid()) {
                    console.log('invalid date!', date);
                    return '-';
                  }
                }
                return dateM.format('DD.MM.YYYY');
            },
            onModalClose() {
                this.$emit('update:vehicleSelected', '')
                this.$emit('update:newMileageModalActive', false)
            },
            toggleApiActive() {
                this.$emit('update:apiInProgress', !this.apiInProgress);
            },
            async sendMileage() {

                    if (!this.mileageUnmasked) return this.newMileageData.mileageWarning = this.$t('myFleet.enterNewMileage');
                    if (this.mileageUnmasked <= this.newMileageData.lastDocumentedMileage) return this.newMileageData.mileageWarning = this.$t('myFleet.newMileageError');;


                    this.toggleApiActive();
                    let newMileage = await this.$store.fleet.actions.sendMileage(this.mileageUnmasked, this.vehicleSelected).catch( (err) => { console.error('problemi;', err); respError = err;});
                    //this.driverChangeInProgress = false;
                    this.toggleApiActive();
                    if (!newMileage || !newMileage.output || newMileage.output.status !== "success") {
                        console.log('respError', newMileage);
                        return alerts.error(newMileage.info ? newMileage.info.message : '');
                    }

                    let contractObject = this.$store.fleet.store.fleetData.data.contracts.find( ({ auto }) => auto._id === this.vehicleSelected);

                    if (contractObject && contractObject.mileage && !contractObject.mileage.lastDocumentedMileage) contractObject.mileage.lastDocumentedMileage = {};
                    if (contractObject && contractObject.mileage) {
                      contractObject.mileage.lastDocumentedMileage.mileageDate = newMileage.output.mileage.mileageDate;
                      contractObject.mileage.lastDocumentedMileage.km = newMileage.output.mileage.km;
                    }
                    this.mileageUnmasked = '';
                    this.newMileageData.newMileage = '';
                    this.newMileageData.lastDocumentedMileage = '';
                    this.onModalClose();

                    swal({
                        title: this.$t('myFleet.newMileageSuccess'),
                        type: 'success',
                        timer: 2000,
                        showConfirmButton: false
                    }).catch(err => {});
            }
        },
        directives: {
            imask: IMaskDirective
        }
    }
</script>
<style scoped>
.error-text {
  display: block;
}
.mileage-warning-km {
  margin-bottom: 0px;
}
</style>
